import * as React from 'react';
import axios from 'axios';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { Button, Link, TextField, CssBaseline } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { styled, createTheme } from '@mui/material/styles';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

const PasswordText = styled('p')({
  position: 'absolute',
  right: '16px',
  top: '50%',
});

export default function PasswordModalPopup({ modalOpen, handleClose }) {
  const UserData = JSON.parse(sessionStorage.getItem('login_info'));
  const [userPassword, setUserPassword] = React.useState('');
  const [userNewPassword, setUserNewPassword] = React.useState('');
  const [userNewPasswordConfirm, setUserNewPasswordConfirm] = React.useState('');

  const [emailSendLoading, setEmailSendLoading] = React.useState(false);

  const [pwCheck, setPwCheck] = React.useState(false);
  const [regExp, setRegExp] = React.useState(false);

  const onUserPasswordHandle = (e) => {
    setUserPassword(e.target.value);
  };
  const onUserNewPasswordHandle = (e) => {
    setUserNewPassword(e.target.value);
  };
  const onUserNewPasswordConfirmHandle = (e) => {
    setUserNewPasswordConfirm(e.target.value);
  };

  const handleInputPW = (e) => {
    if (e.target.id === 'password') {
      setUserNewPassword(e.target.value); // 비밀번호 입력
      const regExp = /(?=.*\d{1,50})(?=.*[~`!@#$%^&*()-+=]{1,50})(?=.*[a-zA-Z]{2,50}).{8,50}$/;
      setRegExp(regExp.test(e.target.value)); // 정규식 체크
    } else if (e.target.id === 'rePassword') {
      setUserNewPasswordConfirm(e.target.value); // 입력
      if (userNewPassword === e.target.value) {
        // 일치 확인
        setPwCheck(true);
      } else {
        setPwCheck(false);
      }
    }
  };

  const handleClick = (e) => {
    const sendData = {
      email: UserData.login_id,
      password: userPassword,
      inviteUser: '',
    };
    // console.log('sendData', sendData)
    axios({
      url: `${process.env.REACT_APP_SERVER_URL}/user/login`,
      method: 'post',
      data: sendData,
    })
      .then((response) => {
        console.log(response.data[0][0].user_token);
        if (response.data[0][0].result === 'fail') {
          alert('기존 비밀번호를 확인해 주세요.');
        } else if (Object.prototype.hasOwnProperty.call(response.data[0][0], 'user_token')) {
          console.log('여기', response.data[0][0]);
          changePassword();
        } else {
          alert('서버 오류');
        }
      })
      .catch((error) => {
        console.log('error', error);
      });
  };

  const changePassword = () => {
    const param = {
      user_email: `${UserData.login_id}`,
      user_password: `${userNewPassword}`,
    };

    axios({
      url: `${process.env.REACT_APP_SERVER_URL}/user/password`,
      method: 'post',
      data: param,
    })
      .then((response) => {
        console.log('response', response.data[0][0].result);
        if (response.data[0][0].result === 'success') {
          alert('비밀번호가 변경되었습니다.');
          handleClose();
        } else {
          alert('알수없는 오류가 발생했습니다. 오류가 지속되면 문의해주시기 바랍니다.');
          handleClose();
        }
        // response 결과보고 판단하는 로직 추가 필요 23/02/02 cheol-ha
      })
      .catch((error) => {
        // console.log('error', error);
        setEmailSendLoading(false);
      });
  };

  const contactHandleClose = () => {
    handleClose();
  };

  return (
    <>
      <Modal
        open={modalOpen}
        onClose={contactHandleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box
          sx={{
            ...modalStyle,
            width: 800,
            display: 'flex',
            flexDirection: 'column',
            padding: '60px',
            border: '1px solid #ddd',
            borderRadius: '40px',
          }}
        >
          <div>
            <TextField
              required
              fullWidth
              id="inquiryname"
              name="inquiryname"
              type="password"
              onKeyUp={onUserPasswordHandle}
              label="기존 비밀번호를 입력하세요."
            />

            <TextField
              required
              fullWidth
              type="password"
              id="password"
              name="password"
              label="새로운 비밀번호를 입력하세요."
              // onChange={handleInputPW}
              onKeyUp={handleInputPW}
            />
            {!regExp && userNewPassword !== '' ? (
              <PasswordText style={{ fontSize: 'smaller', color: 'red' }}>
                8자 이상 영문, 숫자, 특수문자가 조합되어야합니다.
              </PasswordText>
            ) : null}
            {regExp && userNewPassword !== '' ? (
              <PasswordText style={{ fontSize: 'smaller', color: 'blue' }}>사용가능한 비밀번호 입니다. </PasswordText>
            ) : null}

            <TextField
              required
              fullWidth
              type="password"
              id="rePassword"
              name="rePassword"
              label="새로운 비밀번호을 확인해주세요."
              onChange={handleInputPW}
            />
            {!pwCheck && userNewPasswordConfirm !== '' ? (
              <PasswordText style={{ fontSize: 'smaller', color: 'red' }}>비밀번호가 일치하지 않습니다.</PasswordText>
            ) : null}
            {pwCheck && userNewPasswordConfirm !== '' ? (
              <PasswordText style={{ fontSize: 'smaller', color: 'blue' }}>비밀번호가 일치합니다.</PasswordText>
            ) : null}

            {/* <TextField  type={'password'} sx={{marginTop:'10px'}} required fullWidth onKeyUp={onUserNewPasswordHandle} id="inquiryemail" name="inquiryemail"  label="새로운 비밀번호를 입력하세요." />
            <TextField type={'password'} sx={{marginTop:'10px'}} required fullWidth onKeyUp={onUserNewPasswordConfirmHandle} id="inquiryphone" name="inquiryphone" label="새로운 비밀번호을 확인해주세요." /> */}
          </div>
          <div style={{ marginTop: '40px', textAlign: 'center' }}>
            <Button variant="contained" disabled={!pwCheck} onClick={handleClick}>
              변경하기
            </Button>
          </div>
        </Box>
      </Modal>

      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 20 }} open={emailSendLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
